<template>
    <div class="account main-style">
        <div v-if="account == null">
            <a @click="toLogin" style="border: 1px solid #14aab9;">
                <i class="fa fa-sign-in" aria-hidden="true" style="margin-right: 6px;"></i>
                登录/注册
            </a>
            <!--            <a @click="registerVisible=true;resetForm()">注册</a>-->
        </div>

        <div v-if="account != null">
            <el-popover :width="79" placement="bottom" trigger="click">
                <div class="popover user-menu main-style">
                    <router-link to="/user"><i class="fa fa-user-circle-o" aria-hidden="true"></i>&nbsp;&nbsp;用户中心</router-link><br />
                    <router-link to="/user/msg">
                        <span v-if="count == 0"><i class="fa fa-envelope" aria-hidden="true"></i>&nbsp;&nbsp;我的消息</span>
                        <el-badge :value=count :max="99" class="item" v-if="count != 0">
                            <i class="fa fa-envelope" aria-hidden="true"></i>&nbsp;&nbsp;我的消息
                        </el-badge>
                    </router-link><br />
                    <a @click="signout"><i class="fa fa-sign-out" aria-hidden="true"></i>&nbsp;&nbsp;退出登录</a>
                </div>
                <el-button type="text" slot="reference" style="    padding-top: 9px;"><i class="el-icon-user-solid" style="margin-right: 6px;"></i>
                    <div style="display: inline; color: #000000;">{{ account.username }}</div>
                </el-button>
            </el-popover>
        </div>

        <el-dialog title="灯塔索引登录" :visible.sync="loginVisible" :close-on-click-modal="false" width="350px" center>
            <el-form size="small" :model="loginForm" label-position="top" :rules="rules" status-icon ref="loginForm" label-width="70px" class="demo-ruleForm">
                <el-form-item label="账号" prop="username">
                    <el-input placeholder="请输入用户名或邮箱" type="text" v-model="loginForm.username" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input placeholder="请输入密码" type="password" v-model="loginForm.password" autocomplete="off"></el-input>
                </el-form-item>

                <el-button class="submit-btn" size="medium" type="primary" @click="login" style="width: 100%">登 录</el-button>
                <div style="padding-top: 30px;">
                    <a style="background: initial; color: #3cb5da; font-size: 12px;float: right" @click="forgetVisible = true; loginVisible = false; resetForm()">忘记密码</a>
                    <div style="font-size: 12px; padding-bottom: 20px;">
                        没有账号?<a style="background: initial; color: #f5415e; font-size: 12px; padding: 0;" @click="registerVisible = true; loginVisible = false; resetForm()">立即注册 ></a>
                    </div>
                </div>
            </el-form>
        </el-dialog>

        <el-dialog title="忘记密码" class="forget-dialog" :visible.sync="forgetVisible" :close-on-click-modal="false" width="400px" center>
            <el-form size="small" :model="regForm" label-position="top" :rules="ruleForget" status-icon ref="forgetForm" label-width="70px" class="demo-ruleForm">
                <el-form-item label="用户名" prop="username">
                    <el-input type="text" v-model="regForm.username" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input type="text" v-model="regForm.email" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="验证码">
                    <el-input placeholder="请登录邮箱查看验证码" v-model="regForm.code" autocomplete="off">
                        <el-button slot="append" @click="sendVerify(2)">发送</el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input type="password" v-model="regForm.password" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认" prop="passwordConfirm">
                    <el-input type="password" v-model="regForm.passwordConfirm" autocomplete="off"></el-input>
                </el-form-item>
                <el-button class="submit-btn" size="medium" type="primary" @click="forget" style="width: 100%;margin-bottom: 20px;">重置密码</el-button>
            </el-form>
        </el-dialog>

        <el-dialog class="reg-dialog" title="灯塔索引注册" :visible.sync="registerVisible" :close-on-click-modal="false" width="400px" center>
            <el-form size="small" :model="regForm" label-position="top" :rules="rules" status-icon ref="regForm" label-width="70px" class="demo-ruleForm">
                <el-form-item label="用户名" prop="username">
                    <el-input placeholder="请输入6-18位的用户名，可以使用字母数据下划线，以英文字母开头" type="text" v-model="regForm.username" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input placeholder="请输入邮箱" type="text" v-model="regForm.email" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="验证码">
                    <el-input placeholder="请登录邮箱查看验证码" v-model="regForm.code" autocomplete="off">
                        <el-button slot="append" @click="sendVerify(1)">发送</el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input placeholder="请输入8-24位的密码，必须包含字母数字和特殊符号" type="password" v-model="regForm.password" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认" prop="passwordConfirm">
                    <el-input placeholder="请再次输入密码" type="password" v-model="regForm.passwordConfirm" autocomplete="off"></el-input>
                </el-form-item>
                <el-button class="submit-btn" size="medium" type="primary" @click="reg" style="width: 100%;margin-bottom: 20px;">注 册</el-button>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import request from '@/utils/request'
import { eventBus } from "../main";
import { mapState } from 'vuex';

export default {
    name: 'AccountWiget',
    created() {
        let token = localStorage.getItem('token')
        if (token != null) {
            this.getInfo(token, false)
        }
        // 刚进入网址时获取一次，以确保用户直接点击用户名后的弹出框中我的消息有未读消息数
        // this.ssoLogin()
        this.routeChange()
    },
    computed: {
        ...mapState(['count'])
    },
    watch: {
        // 如果路由有变化，会再次执行该方法
        '$route': 'routeChange'
    },
    mounted() {
        eventBus.$on('show-login', (message) => {
            location.href = `${this.global.oauthApi}/login?redirect_uri=${this.global.domain}`

            // this.loginVisible = true;
            // this.resetForm()
        });
    },
    data() {
        var validateMail = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入邮箱'));
            } else {
                callback();
            }
        };
        var validateUsername = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入用户名'));
            } else {
                callback();
            }
        };
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.regForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            account: null,
            loginVisible: false,
            registerVisible: false,
            forgetVisible: false,
            loginForm: {
                username: '', password: ''
            },
            regForm: {
                username: '', email: '', password: '', passwordConfirm: '', code: ''
            },
            ruleForget: {
                email: [
                    { validator: validateMail, trigger: 'blur' }
                ],
                password: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                passwordConfirm: [
                    { validator: validatePass2, trigger: 'blur' }
                ]
            },
            rules: {
                username: [
                    { validator: validateUsername, trigger: 'blur' }
                ],
                email: [
                    { validator: validateMail, trigger: 'blur' }
                ],
                password: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                passwordConfirm: [
                    { validator: validatePass2, trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        routeChange(e) {
            if (this.$route.query.cmd === 'login') {
                this.$router.replace('/')
                eventBus.$emit('show-login', '');
            }

            if (this.global.account != null) {
                request({
                    url: "/api/user/unredmsg",
                    method: "post",
                    data: { token: this.global.account.token }
                }).then((r) => {
                    this.$store.commit('Assign', r)
                })
            }

        },
        reg() {
            this.$refs['regForm'].validate((valid) => {
                if (valid) {
                    request({
                        url: "api/login/reg",
                        method: "post",
                        data: this.regForm
                    }).then((r) => {
                        console.log(r);
                        if (r.code != 200) {
                            this.$message.error(r.msg);
                            return;
                        }
                        this.authDone(r.info.token)
                    }).catch(error => {
                        console.log(error);
                    });
                } else {
                    return false;
                }
            });

        },
        forget() {
            this.$refs['forgetForm'].validate((valid) => {
                if (valid) {
                    request({
                        url: "api/login/reset",
                        method: "post",
                        data: this.regForm
                    }).then((r) => {
                        console.log(r);
                        if (r.code != 200) {
                            this.$message.error(r.msg);
                            return;
                        }

                        this.forgetVisible = false;
                        this.loginVisible = true;
                        this.$message.success("重置成功,请登录")
                    }).catch(error => {
                        console.log(error);
                    });
                } else {
                    return false;
                }
            });
        },
        sendVerify(type) {
            if (this.regForm.username.length < 1) {
                this.$message.error("用户名必填");
                return;
            }
            if (this.regForm.email.length > 0) {
                request({
                    url: "api/login/send_verify",
                    method: "post",
                    data: { email: this.regForm.email, type: type, username: this.regForm.username }
                }).then((r) => {
                    console.log(r);
                    if (r.code != 200) {
                        this.$message.error(r.msg);
                        return;
                    }
                    this.$message.success("发送成功")
                }).catch(error => {
                    console.log(error);
                });
            }
        },
        login() {
            this.$refs['loginForm'].validate((valid) => {
                if (valid) {
                    request({
                        url: "api/login/auth",
                        method: "post",
                        data: this.loginForm
                    }).then((r) => {
                        console.log(r);
                        if (r.code != 200) {
                            this.$message.error(r.msg);
                            return;
                        }
                        this.$router.go(0)
                        this.authDone(r.info.token)
                    }).catch(error => {
                        console.log(error);
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm() {
            this.loginForm = {
                username: '', password: ''
            }
            this.regForm = {
                username: '', email: '', password: '', passwordConfirm: '', code: ''
            }
        },
        authDone(token) {
            console.log(token)
            this.loginVisible = false
            this.registerVisible = false

            localStorage.setItem('token', token)

            this.getInfo(token, true)
        },
        getInfo(token, hint) {
            request({
                url: "api/login/getInfo",
                method: "post",
                data: { token: token }
            }).then((r) => {
                if (r.code != undefined) {
                    this.$message.error(r.msg);
                    localStorage.removeItem('token')
                    return;
                }
                r.token = token
                this.account = r
                this.global.account = r

        console.log({ getInfoglobal: this.global });
                if (hint) {
                    this.$message({
                        message: '欢迎回来，' + r.username,
                        type: 'success'
                    });
                }
            }).catch(error => {
                console.log(error);
            });
        },
        async signout() {
            this.account = null;            
            this.global.account = null;
            // const ssotoken = localStorage.getItem('ssoToken')
            // const token = localStorage.getItem('token')

            await request({
                url:"api/login/logout",
                method:"post",
                
            })

            

            localStorage.removeItem('token')
            localStorage.removeItem('ssoToken')
            this.global.account = null
            this.$router.replace('/')
            this.$message({
                message: '退出成功',
                type: 'success'
            });
        },
        toLogin() {
            // location.href = `${this.global.oauthApi}/login?redirect_uri=http://localhost:8080`
            location.href = `${this.global.oauthApi}/login?redirect_uri=${this.global.domain}`
            // loginVisible=true;
            // resetForm()
        },
        ssoLogin() {
            // console.log('ssoLogin');
            const ssoToken = this.$route.query.t
            // console.log({ssoToken})
            // console.log({query:this.$route.query})
            if (ssoToken) {
                request({
                    url: "api/login/ssoAuth",
                    method: "post",
                    data: {
                        sso_token: ssoToken
                    }
                }).then((r) => {
                    localStorage.setItem('ssoToken', r.info.ssoToken)
                    localStorage.setItem('token', r.info.token)
                    this.authDone(r.info.token)
                }).catch(error => {
                    console.log(error);
                });
            }
        }
    }
}
</script>

<style>
.account .el-dialog__title {
    font-weight: bold;
    padding-bottom: 6px;
    border-bottom: 2px solid #14aab9;
    line-height: 36px;
}

.account .el-dialog__header {
    text-align: left;
}

.account .el-form-item__label {
    line-height: 20px;
    /*padding: 0;*/
}

.account .el-form-item__error {
    right: 0;
    left: initial;
    top: -80%;
}

.account .el-form-item {
    margin-bottom: 20px;
}

.account .el-input-group__append {
    background-color: #14aab9;
    color: #ffffff;
}

.account .el-input-group__append:hover {
    background-color: #14aab9;
    color: #ffffff;
}

.account .el-button:focus:not(.el-button--text),
.account .el-button:hover:not(.el-button--text) {
    border-color: transparent;
    background-color: #14aab9;
    color: white;
}

.account .el-dialog__body {
    padding: 16px 40px;
}

.account .reg-dialog .el-dialog__body,
.account .forget-dialog .el-dialog__body {
    padding: 10px 20px 20px;
}

.account .el-dialog__header {
    border-bottom: 1px solid #efe9e9;
    padding: 20px 0 0;
    margin: 20px;
}

.account .el-dialog__headerbtn {
    top: 30px;
}

.account .el-form-item__label {
    color: black;
    font-weight: bold;
}
</style>

<style scoped>
.submit-btn {
    margin-top: 12px;
}

.user-menu {
    text-align-last: center;
}

.user-menu a {
    line-height: 30px;
}

.user-menu a:hover {
    color: #1cc3d5;
}

.top {
    width: 100%;
    height: 36px;
    background: #555555;
    line-height: 36px;
    font-size: 12px;
    color: #aaa;
    min-width: 1200px;
}

.w1200 {
    width: 1200px;
}

.w1200 a {
    color: #aaa;
}

.w1200 span em {
    margin: 0 8px
}

#date em {
    margin-left: 8px;
}

.head {
    /* width: 1200px; */
    padding: 0 10px;
    height: 94px;
    padding-top: 10px;
}

.logo {
    float: left;
}

.white {
    width: 100%;
    height: 94px;
    /* background: white;  */
    min-width: 1200px;
}


.account {
    float: right;
    margin-right: 40px;
}

.account a {
    /*background: #14aab9;*/
    border-radius: 4px;
    color: #14aab9;
    padding: 0 10px;
    height: 33px;
    line-height: 33px;
    text-align: center;
    display: inline-block;
    margin-left: 10px;
}

.nav {
    width: 100%;
    height: 0px;
    background: #14aab9;
}

.nav ul {
    width: 1200px;
}

.nav ul li {
    float: left;
    height: 45px;
    width: 133px;
    line-height: 45px;
    font-size: 16px;
    text-align: center;
    transition: all 0.3s;
}

.nav ul li a {
    color: #fff;
    display: block;
}

.nav ul li.on,
.nav ul li:hover {
    background: #c9380c;
}

.nav ul li.on a,
.nav ul li:hover a {
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/AccountWiget.vue